export function toNumber(value: unknown): number | null {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  if (typeof value !== 'string') {
    return null;
  }

  const original = value.trim();
  if (!original || ['nan', 'none', 'n.d.', 'dadefinire', 'da definire'].includes(original.toLowerCase())) {
    return null;
  }

  const isPercent = original.includes('%');
  let text = original
    .toLowerCase()
    .replace(/\s/g, '')
    .replace(/hres\.perdip/g, '')
    .replace(/eur|€|gg|giorni|ore|unita|unità|h/g, '')
    .replace(/>=|<=|>|<|ca\.|~/g, '');

  const commaIndex = text.lastIndexOf(',');
  const dotIndex = text.lastIndexOf('.');

  if (commaIndex >= 0 && dotIndex >= 0) {
    if (commaIndex > dotIndex) {
      text = text.replace(/\./g, '').replace(',', '.');
    } else {
      text = text.replace(/,/g, '');
    }
  } else if (commaIndex >= 0) {
    text = text.replace(',', '.');
  }

  text = text.replace(/[^0-9+\-.eE]/g, '');
  const parsed = Number(text);
  if (!Number.isFinite(parsed)) {
    return null;
  }

  return isPercent && Math.abs(parsed) > 1 ? parsed / 100 : parsed;
}
